
import { Placement } from '@post-office/placements-frontend/jira-sidenav4-mpac-recommendations';
export default Placement;
